import { IAudienceMinuteState, IEPGProgramState } from '../Timeline/Types';

export enum TimelinePopoversActionTypes {
    SET_BACKGROUND_POPOVER = '@@timeline/SET_BACKGROUND_POPOVER',
    SET_BROADCASTER_POPOVER = '@@timeline/SET_BROADCASTER_POPOVER',
    SET_CURRENT_MINUTE = '@@timeline/SET_CURRENT_MINUTE',
    SET_DECLARATIVE_POPOVER = '@@timeline/SET_DECLARATIVE_POPOVER',
    SET_DECLARATIVERADIO_POPOVER = '@@timeline/SET_DECLARATIVERADIO_POPOVER',
    SET_MUSIC_POPOVER = '@@timeline/SET_MUSIC_POPOVER',
    SET_READJUSTED_POPOVER = '@@timeline/SET_READJUSTED_POPOVER',
    SET_TALK_POPOVER = '@@timeline/SET_TALK_POPOVER',
    SET_XML_POPOVER = '@@timeline/SET_XML_POPOVER',
}

export interface ITimelinePopoversState {
    readonly currentAudienceMinute: IAudienceMinuteState;
    readonly popoverBackground: IEPGProgramState | null;
    readonly popoverBroadcaster: IEPGProgramState | null;
    readonly popoverDeclarative: IEPGProgramState | null;
    readonly popoverDeclarativeRadio: IEPGProgramState | null;
    readonly popoverMusic: IEPGProgramState | null;
    readonly popoverReadjusted: IEPGProgramState | null;
    readonly popoverTalk: IEPGProgramState | null;
    readonly popoverXML: IEPGProgramState | null;
}

export interface ISetBackgroundPopoverAction {
    payload: IEPGProgramState | null;
    type: TimelinePopoversActionTypes.SET_BACKGROUND_POPOVER;
}

export interface ISetBroadcasterPopoverAction {
    payload: IEPGProgramState | null;
    type: TimelinePopoversActionTypes.SET_BROADCASTER_POPOVER;
}

export interface ISetCurrentMinuteAction {
    payload: IAudienceMinuteState | null;
    type: TimelinePopoversActionTypes.SET_CURRENT_MINUTE;
}

export interface ISetDeclarativePopoverAction {
    payload: IEPGProgramState | null;
    type: TimelinePopoversActionTypes.SET_DECLARATIVE_POPOVER;
}

export interface ISetDeclarativeRadioPopoverAction {
    payload: IEPGProgramState | null;
    type: TimelinePopoversActionTypes.SET_DECLARATIVERADIO_POPOVER;
}

export interface ISetMusicPopoverAction {
    payload: IEPGProgramState | null;
    type: TimelinePopoversActionTypes.SET_MUSIC_POPOVER;
}

export interface ISetReadjustedPopoverAction {
    payload: IEPGProgramState | null;
    type: TimelinePopoversActionTypes.SET_READJUSTED_POPOVER;
}

export interface ISetTalkPopoverAction {
    payload: IEPGProgramState | null;
    type: TimelinePopoversActionTypes.SET_TALK_POPOVER;
}

export interface ISetXMLPopoverAction {
    payload: IEPGProgramState | null;
    type: TimelinePopoversActionTypes.SET_XML_POPOVER;
}
